// Branding sets the editor's font from the DESTINATION's theme, so its surface
// must come from there too — Studio's own `paper` put light text on light.

const HEX_COLOR = /^#[0-9A-F]{6}$/i;
const PASS_THROUGH = ["transparent", "unset"];

export function isVclValidColor(value) {
  if (!value || typeof value !== "string") {
    return false;
  }
  if (PASS_THROUGH.includes(value)) {
    return true;
  }
  if (HEX_COLOR.test(value)) {
    return true;
  }
  // A theme alias ("color.background.paper"); anything else is not a colour.
  return value.includes(".");
}

export function editorSurfaceColor(resolvedColor, fallbackAlias) {
  return isVclValidColor(resolvedColor) ? resolvedColor : fallbackAlias;
}
